exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".response-dialog {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  margin: 0;\n  padding: 15px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.response-dialog .success-icon {\n  width: 60px;\n  height: 60px;\n  color: green;\n  font-size: 4em; }\n\n.response-dialog .error-icon {\n  width: 60px;\n  height: 60px;\n  color: red;\n  font-size: 4em; }\n\n.response-dialog .warning-icon {\n  width: 60px;\n  height: 60px;\n  color: orange;\n  font-size: 4em; }\n\n.response-dialog p {\n  font-size: 1.2em;\n  text-align: left;\n  margin: 0 0 10px 0;\n  padding: 0; }\n\n.response-dialog button {\n  color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/response-dialog/response-dialog.component.scss
// module id = ../../../../../src/app/shared/components/response-dialog/response-dialog.component.scss
// module chunks = main